/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-18 17:43:14
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-05-01 23:02:13
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHeader/PromotionBarContent/index.tsx
 */
import { ItemWrapper } from '@/src/components';
import { SectionContainer } from '@/src/components/Layouts';
import moment, { Moment } from 'moment';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import Editor from 'src/constrains/BraftEditor';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import TimeOrderedList from '../../Components/TimeOrderedList';
import {
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getNewPromotion,
  getPromotionBarContent,
  getPromotionBarContents,
  getSubmitStamp,
  getTimeZone,
  onAddNewItem,
  onChangeItemProp,
  onCloneItem,
  onCollapseOpen,
  onDeleteItem,
  onDragSorting,
  onErrorChange,
} from '../slice';
import { promotionBarContentValidation } from '../tool';
import styles from './style.less';
function PromotionBarContent(props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { contentUuid, isOnPrimaryLanguage } = props;
  const dispatch = useDispatch();
  const timeZone = useSelector(getTimeZone());
  const newPromotion = useSelector(getNewPromotion());
  // const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });

  const handleChangeTime = (
    item: any,
    isNew: boolean,
    start: Moment,
    end: Moment,
  ) => {
    const beginDate = start ? moment(start).format('YYYY-MM-DD') : null;
    const beginTime = start ? moment(start).format('HH:mm') : null;
    const endDate = end ? moment(end).format('YYYY-MM-DD') : null;
    const endTime = end ? moment(end).format('HH:mm') : null;
    dispatch(
      onChangeItemProp({
        uuid: item.uuid,
        prop: 'beginDate',
        value: beginDate,
        isNew,
      }),
    );
    dispatch(
      onChangeItemProp({
        uuid: item.uuid,
        prop: 'beginTime',
        value: beginTime,
        isNew,
      }),
    );
    dispatch(
      onChangeItemProp({
        uuid: item.uuid,
        prop: 'endDate',
        value: endDate,
        isNew,
      }),
    );
    dispatch(
      onChangeItemProp({
        uuid: item.uuid,
        prop: 'endTime',
        value: endTime,
        isNew,
      }),
    );
  };

  const getErrorProcessingComponentProps = (item: any, isNew: boolean) => {
    return {
      getCollapseOpenStatus,
      expandOffset: props.isResponsive ? 0 : undefined,
      onCollapseOpen,
      headerProps: {
        hasDots: !isNew,
        hideDotsWhenNotPrimary: true,
        dotsFunction: isNew
          ? []
          : [
              {
                onClick: () => {
                  dispatch(onCloneItem({ uuid: item.uuid }));
                },
                key: 'Duplicate',
                body: getI18n('general.duplicate'),
              },
              {
                key: 'Delete',
                body: getI18n('general.delete'),
                isDangerous: true,
                displayWarningModal: true,
                onClick: () => void 0,
                modalOnOk: () => {
                  dispatch(onDeleteItem({ uuid: item.uuid }));
                },
                modalTitle: getI18n(
                  'salesChannelContent.index.deletePromotionBarContent',
                ),
                modalContent: getI18n(
                  'salesChannelContent.index.deletePromotionBarContentTip',
                ),
              },
            ],
      },
      id: item.uuid,
      getContent: () => getPromotionBarContent(item.uuid, isNew),
      getErrorDisplay: getCollapseValidationMsgDisplay,
      onErrorChange,
      getSubmitStamp,
      validation: (x) => {
        return promotionBarContentValidation(x);
      },
    };
  };

  const renderChild = (item: any, isNew: boolean, disabled: boolean) => {
    return (
      <SectionContainer size={'small'} className={styles.container}>
        <ItemWrapper size={'small'} title={getI18n('general.content.text')}>
          <Editor
            disabled={disabled}
            salesChannelContentUuid={contentUuid}
            data={item.text}
            onChange={({ data }) =>
              dispatch(
                onChangeItemProp({
                  uuid: item.uuid,
                  prop: 'text',
                  value: data,
                  isNew,
                }),
              )
            }
          />
        </ItemWrapper>
      </SectionContainer>
    );
  };

  return (
    <div
      className={styles.container}
      style={{ paddingRight: props.isResponsive ? '10px' : undefined }}>
      <TimeOrderedList
        isResponsive={props.isResponsive}
        hideAddButton={!isOnPrimaryLanguage}
        hideName={!isOnPrimaryLanguage}
        hideTimeEdit={!isOnPrimaryLanguage}
        title={getI18n('salesChannelContent.index.promotionBarContent')}
        timeZone={timeZone}
        buttonText={getI18n('salesChannelContent.index.promotionBarContent')}
        titlePropertyName={'name'}
        list={() => useSelector(getPromotionBarContents())}
        getErrorProcessingComponentProps={getErrorProcessingComponentProps}
        renderSingleChild={renderChild}
        onAddNewItem={() => dispatch(onAddNewItem({}))}
        onChangeItemName={(item: any, isNew: boolean, value: any) => {
          dispatch(
            onChangeItemProp({ uuid: item.uuid, prop: 'name', value, isNew }),
          );
        }}
        onDragSorting={(a, b) => {
          const { oldIndex, newIndex } = b;
          dispatch(onDragSorting({ oldIndex, newIndex }));
        }}
        onChangeTime={handleChangeTime}
        newItem={newPromotion}
      />
    </div>
  );
}

export default PromotionBarContent;
